import React from 'react';
import { observer } from 'mobx-react';
import { Grid, Typography } from '@mui/material';
import { useDisplayStringValue } from '@gamiphy/react-i18n';
import { TierColors } from '@gamiphy/bl/level';
import ProgressDescription from '@gamiphy/loyalty/levels/components/ProgressDescription';
import { useLoyaltyPageContext } from '../../context';

type Props = {
  progress: number,
}

const CircularStatus: React.FC<Props> = observer(({ progress }) => {
  const circularProgress = React.useMemo(() => progress * 360, [progress]);
  const {
    currentTier, tiers, nextTier, tierConfig, tiersAccumulatedValue,
  } = useLoyaltyPageContext();
  const levelName = useDisplayStringValue(currentTier?.name);
  return (
    <Grid
      sx={{
        width: '100%',
        borderRadius: '8px',
        textAlign: 'center',
      }}
      container
      direction="column"
      alignItems="center"
    >
      <Grid
        sx={{
          position: 'relative',
          height: 233,
          width: 233,
          borderRadius: '50%',
          background: `conic-gradient(${currentTier?.color ?? TierColors.bronze}, ${currentTier?.color ?? TierColors.bronze} ${circularProgress}deg, #ccc 0deg)`,
          '&::before': {
            content: '""',
            position: 'absolute',
            height: 227,
            width: 227,
            backgroundColor: '#FFF2E8',
            borderRadius: '50%',
          },
          '@media (min-width: 600px)': {
            width: 324,
            height: 324,
            '&::before': {
              width: 315,
              height: 315,
            },
          },
        }}
        container
        alignItems="center"
        justifyContent="center"
      >
        <Grid
          sx={{
            zIndex: 0,
            paddingInline: 2,
            fontSize: '12px',
            fontWeight: 600,
            p: 4,
          }}
          container
          justifyContent="center"
          alignItems="center"
        >
          <Grid mb={2} size={12}>
            <Typography
              fontSize={{
                xs: 18,
                sm: 24,
              }}
              fontWeight={700}
              textTransform="capitalize"
            >
              <Grid size={12}>
                {levelName}
              </Grid>
            </Typography>
          </Grid>
          <Grid sx={{
            overflow: 'hidden',
            paddingInline: 1,
          }}
          >
            <Typography
              variant="body1"
              fontSize={{
                xs: 14,
                sm: 18,
              }}
            >
              <ProgressDescription
                tiers={tiers}
                nextTier={nextTier}
                tierConfig={tierConfig}
                accumulated={tiersAccumulatedValue}
              />
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
});

export default CircularStatus;
